// Glowkeep uploader: order number + email -> session -> files straight into R2 via the upload API
// (single PUT under 80 MB, otherwise 40 MB multipart parts), with per-file progress. Pre-fills from ?order=&email=.
function initUpload(root){
  const $ = s => root.querySelector(s);
  const api = (root.dataset.api || '').replace(/\/+$/, '');
  const find = $('[data-ref="find"]'), findMsg = $('[data-ref="findMsg"]'), findBtn = $('[data-ref="findBtn"]');
  const filesCard = $('[data-ref="files"]'), orderBox = $('[data-ref="order"]'), list = $('[data-ref="list"]'), msg = $('[data-ref="msg"]');
  const count = $('[data-ref="count"]'), drop = $('[data-ref="drop"]'), input = $('[data-ref="file"]'), doneBtn = $('[data-ref="done"]');
  const finished = $('[data-ref="finished"]'), note = $('[data-ref="note"]');
  let session = null, max = 12, files = [], uploading = 0;

  const qs = new URLSearchParams(location.search);
  if (qs.get('order')) find.order.value = qs.get('order').replace('#', '');
  if (qs.get('email')) find.email.value = qs.get('email');

  const fmt = b => b > 1e9 ? (b / 1e9).toFixed(2) + ' GB' : b > 1e6 ? (b / 1e6).toFixed(1) + ' MB' : Math.round(b / 1e3) + ' KB';
  async function call(path, opts = {}){
    const r = await fetch(api + path, { headers: { 'Content-Type': 'application/json' }, ...opts });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.error || 'Something went wrong. Try again.');
    return j;
  }

  find.addEventListener('submit', async e => {
    e.preventDefault(); findMsg.textContent = ''; findBtn.disabled = true; findBtn.textContent = 'Looking…';
    try {
      const j = await call('/session', { method: 'POST', body: JSON.stringify({ order: find.order.value, email: find.email.value }) });
      session = j.session; max = j.max || 12; files = j.files || [];
      const items = j.order.items.map(i => `${i.qty} × ${i.title}${i.variant ? ' · ' + i.variant : ''}`).join('<br>');
      orderBox.innerHTML = `<b>Order ${j.order.name}</b><br>${items}` + (j.order.loaded ? '' : '<br><span class="up-warn">This order is for a blank orb, so there is nothing to upload. If you meant to have it loaded, email hello@glowkeep.com.au.</span>');
      find.hidden = true; filesCard.hidden = false; render();
      if (j.order.done && files.length) msg.textContent = 'We already have these files. Add more or remove some; then press the button again when you are done.';
    } catch (err) { findMsg.textContent = err.message; }
    findBtn.disabled = false; findBtn.textContent = 'Find my order';
  });

  function render(){
    list.innerHTML = '';
    for (const f of files){
      const li = document.createElement('li');
      const isVid = /\.(mov|mp4|m4v|hevc|3gp|webm)$/i.test(f.name) || (f.type || '').startsWith('video/');
      li.innerHTML = `<span class="up-kind">${isVid ? 'video' : 'photo'}</span><span class="up-name">${f.name}</span><span class="up-size">${fmt(f.size)}</span>` +
        (f.progress != null && f.progress < 1 ? `<span class="up-bar"><i style="width:${Math.round(f.progress * 100)}%"></i></span>` : `<button type="button" class="thumb-x" aria-label="Remove ${f.name}">✕</button>`);
      const x = li.querySelector('.thumb-x');
      if (x) x.addEventListener('click', () => remove(f));
      list.appendChild(li);
    }
    count.textContent = `${files.filter(f => f.key).length} / ${max}`;
    doneBtn.disabled = !files.some(f => f.key) || uploading > 0;
  }

  async function remove(f){
    if (f.key){ try { await call(`/file?session=${session}&key=${encodeURIComponent(f.key)}`, { method: 'DELETE' }); } catch (e) { msg.textContent = e.message; return; } }
    files = files.filter(x => x !== f); render();
  }

  function put(url, body, type, onProgress){
    return new Promise((resolve, reject) => {
      const x = new XMLHttpRequest(); x.open('PUT', url);
      if (type) x.setRequestHeader('Content-Type', type);
      x.upload.onprogress = e => { if (e.lengthComputable) onProgress(e.loaded / e.total); };
      x.onload = () => { try { const j = JSON.parse(x.responseText || '{}'); x.status < 300 ? resolve(j) : reject(new Error(j.error || 'Upload failed')); } catch (e) { reject(new Error('Upload failed')); } };
      x.onerror = () => reject(new Error('Network error during upload. Check your connection and try again.'));
      x.send(body);
    });
  }

  async function upload(file){
    const entry = { name: file.name, size: file.size, type: file.type, progress: 0 };
    files.push(entry); uploading++; render();
    try {
      const type = file.type || 'application/octet-stream';
      const start = await call('/upload/start', { method: 'POST', body: JSON.stringify({ session, name: file.name, type, size: file.size }) });
      if (!start.uploadId){
        await put(`${api}/upload/single?session=${session}&key=${encodeURIComponent(start.key)}`, file, type, p => { entry.progress = p; render(); });
      } else {
        const size = start.partSize, parts = [], n = Math.ceil(file.size / size);
        for (let i = 0; i < n; i++){
          const chunk = file.slice(i * size, Math.min(file.size, (i + 1) * size));
          const r = await put(`${api}/upload/part?session=${session}&key=${encodeURIComponent(start.key)}&uploadId=${encodeURIComponent(start.uploadId)}&part=${i + 1}`, chunk, 'application/octet-stream', p => { entry.progress = (i + p) / n; render(); });
          parts.push({ partNumber: r.partNumber, etag: r.etag });
        }
        await call('/upload/complete', { method: 'POST', body: JSON.stringify({ session, key: start.key, uploadId: start.uploadId, parts }) });
      }
      entry.key = start.key; entry.progress = 1;
    } catch (e) { files = files.filter(x => x !== entry); msg.textContent = `${file.name}: ${e.message}`; }
    uploading--; render();
  }

  function addFiles(fileList){
    msg.textContent = '';
    for (const f of fileList){
      if (files.length >= max){ msg.textContent = `That's the ${max}-file limit for one orb.`; break; }
      const ok = f.type.startsWith('image/') || f.type.startsWith('video/') || /\.(heic|heif|jpe?g|png|webp|mov|mp4|m4v|hevc|3gp)$/i.test(f.name);
      if (!ok){ msg.textContent = `${f.name} isn't a photo or video.`; continue; }
      upload(f);
    }
  }
  input.addEventListener('change', () => { addFiles(input.files); input.value = ''; });
  ['dragenter', 'dragover'].forEach(e => drop.addEventListener(e, ev => { ev.preventDefault(); drop.classList.add('over'); }));
  ['dragleave', 'drop'].forEach(e => drop.addEventListener(e, ev => { ev.preventDefault(); drop.classList.remove('over'); }));
  drop.addEventListener('drop', ev => addFiles(ev.dataTransfer.files));

  doneBtn.addEventListener('click', async () => {
    doneBtn.disabled = true; doneBtn.textContent = 'Sending…';
    try {
      const j = await call('/done', { method: 'POST', body: JSON.stringify({ session, note: note.value }) });
      filesCard.hidden = true; finished.hidden = false;
      $('[data-ref="finishedText"]').textContent = `We've got ${j.files} file${j.files === 1 ? '' : 's'}. We'll fit them to the round screen, play-test the orb, wrap it and post it with tracking. You'll get an email when it's on its way.`;
      window.scrollTo({ top: finished.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
    } catch (e) { msg.textContent = e.message; doneBtn.disabled = false; doneBtn.textContent = "That's everything, load my orb"; }
  });
  window.addEventListener('beforeunload', e => { if (uploading > 0){ e.preventDefault(); e.returnValue = ''; } });
}

document.querySelectorAll('[data-gk-upload]').forEach(root => { try { initUpload(root); } catch (e) { console.error('Glowkeep upload', e); } });
